module.exports = require("@nestjs/schedule");